import table from '@/assets/table.png';
/**
 * 隐私政策页面组件
 * @component PrivacyPolicy
 * @description 起泡AI隐私政策页面，展示完整的隐私政策内容
 */
export default {
  name: 'PrivacyPolicy',
  data: function data() {
    return {
      table: table
    };
  }
};